/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

'use client';

import React, {
  useCallback, useRef, useState, useEffect,
} from 'react';
import { createPortal } from 'react-dom';
import { HexColorPicker } from 'react-colorful';

import useClickOutside from '../../../hooks/useClickOutside';

export const PopoverPicker = ({
  color, onChange, onClose, onOpen,
}) => {
  const popover = useRef();
  const swatchRef = useRef();
  const [isOpen, toggle] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });

  const open = useCallback(() => {
    if (onOpen) onOpen();
    toggle(true);
  }, [onOpen]);

  const close = useCallback(() => {
    toggle(false);
    if (onClose) onClose();
  }, [onClose]);
  useClickOutside(popover, close);

  useEffect(() => {
    if (isOpen && swatchRef.current) {
      const rect = swatchRef.current.getBoundingClientRect();
      const pickerWidth = 200;
      const pickerHeight = 240;
      let top = rect.bottom + 4;
      let left = rect.left + rect.width / 2 - pickerWidth / 2;

      // Keep within viewport
      if (left < 8) left = 8;
      if (left + pickerWidth > window.innerWidth - 8) left = window.innerWidth - pickerWidth - 8;
      if (top + pickerHeight > window.innerHeight - 8) top = rect.top - pickerHeight - 4;

      setPos({ top, left });
    }
  }, [isOpen]);

  return (
    <div className="color-picker mt-1 mx-2">
      <div
        ref={swatchRef}
        className="color-picker-swatch"
        style={{ backgroundColor: color }}
        onClick={open}
      />

      {isOpen && createPortal(
        <div
          className="color-picker-popover"
          ref={popover}
          style={{
            position: 'fixed', zIndex: 9999, top: pos.top, left: pos.left,
          }}
        >
          <HexColorPicker color={color} onChange={onChange} />
        </div>,
        document.body,
      )}
    </div>
  );
};
